export class BodyItem {
  name: string;
  lstShade: Shade[];

}

export class Shade {
  colorName: string;
  colorCode: string;
  colorEffect: string;
  rvb: string;
  aerosol: string;
  effects: string;
  grpcoul: string;
  dateOfUse: string;
  dateFrom: string;
  dateTo: string;
}
